module.exports = __webpack_public_path__ + "img/wf.3719dc54.svg";